<template>
  <div class="w-full h-full">
    <woot-modal :show.sync="show" :on-close="onClose">
      <woot-modal-header
        :header-title="$t('MERGE_CONTACTS.SCHEDULE_MEETING')"
        :header-content="$t('MERGE_CONTACTS.REMINDER_DESCRIPTION')"
      />

      <div class="schedule-meeting-table">
        <!-- Dropdown to choose between Demo and Set Reminder -->
        <div class="schedule-type">
          <!-- <label>{{ "Schedule Meeting" }}</label> -->
          <select v-model="scheduleType">
            <option value="demo">
              {{ $t('SCHEDULE_MEETING.SET_DEMO.DEMO') }}
            </option>
            <option value="reminder">
              {{ $t('SCHEDULE_MEETING.SET_REMAINDER.REMINDER') }}
            </option>
          </select>
        </div>

        <div v-if="scheduleType === 'reminder'" class="remainder-table">
          <div class="remainder-input date-time">
            <div class="date-time-input">
              <label>
                {{ $t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.LABEL') }}
                <span class="text-red-500">*</span>
              </label>
              <woot-date-time-picker
                :value="scheduledAt"
                class="date-time-picker-modal"
                :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
                :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
                @change="onChange"
              />
            </div>
          </div>
          <div class="remainder-input">
            <label>
              {{ $t('SCHEDULE_MEETING.SET_REMAINDER.REMINDER_NOTE') }}
              <span class="text-red-500">*</span>
            </label>
            <textarea
              v-model="reminderNote"
              placeholder="Enter reminder note"
            ></textarea>
          </div>
        </div>

        <div v-else-if="scheduleType === 'demo'" class="demo-input">
          <div class="remainder-input">
            <label>
              {{ $t('SCHEDULE_MEETING.DEMO.DEMO_NOTE') }}
              <span class="text-red-500">*</span>
            </label>
            <woot-input
              v-model.trim="demoNote"
              :placeholder="'Please Enter Subject'"
              :error="demoNoteError"
              :class="{ error: $v.demoNote?.$error }"
              @input="$v.demoNote.$touch()"
            />
          </div>
          <label>
            {{ $t('SCHEDULE_MEETING.SET_DEMO.SCHEDULE_DEMO') }}
            <!-- <span class="text-red-500">*</span> -->
          </label>
          <a
            v-if="meetingLink"
            :href="meetingLink"
            class="block w-full px-3 py-2 border border-gray-300 text-gray-700 bg-white focus:outline-none focus:ring-1 break-all borderRadius"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ meetingLink }}
          </a>

          <!-- Show input field if no link or invalid -->
          <input
            v-else           
            type="text"
            v-model="meetingLink"
            @input="validateMeetingLink"
            :class="{ 'mb-2': meetingLinkError }"
            :placeholder="$t('SCHEDULE_MEETING.ADD_MEETING_LINK')"
            
          />

          <div v-if="meetingLinkError" class="error-message text-red-500">
            {{ meetingLinkError }}
          </div>

          <div class="remainder-input date-time">
            <div class="date-time-input">
              <label>
                {{ $t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.LABEL') }}
                <span class="text-red-500">*</span>
              </label>
              <woot-date-time-picker
                :value="scheduledAt"
                class="date-time-picker-modal"
                :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
                :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
                @change="onChange"
              />
            </div>
          </div>

          <!-- <div>
            <div
              v-for="(guest, index) in guests"
              :key="index"
              class="input-box flex items-center gap-2"
            >
              <woot-input
                v-model.trim="guests[index]"
                class="w-full"
                :placeholder="'Enter guest Email'"
                :error="getEmailError(index)"
                :class="{ error: $v.guests.$each?.[index]?.$error }"
                @input="$v.guests.$each[index].$touch()"
              />

              Delete button for each input
              <woot-button
                v-tooltip="'Delete'"
                title="Delete"
                icon="delete-contact"
                :viewBox="'0 0 10.456 13.444'"
                size="small"
                :classNames="'alert bg-[rgb(248,248,248)] button button--only-icon contact-modal-links dark:bg-transparent has-tooltip small delete-button'"
                @click="removeInputBox(index)"
              />
            </div>

            Add guest button
            <woot-button
              color-scheme="primary"
              variant="smooth"
              size="small"
              @click="addInputBox"
            >
              Add guest
            </woot-button>
          </div> -->

          <div>
            <div
              v-for="(guest, index) in guests"
              :key="guest.id"
              class="input-box flex items-center gap-2"
            >
              <woot-input
                v-model.trim="guest.email"
                class="w-full"
                :placeholder="'Enter guest Email'"
                :error="getEmailError(index)"
                :class="{ error: $v.guests?.$each?.[index]?.email?.$error }"
                @input="$v.guests.$each[index].email.$touch()"
              />

              <woot-button
                v-tooltip="'Delete'"
                title="Delete"
                icon="delete-contact"
                :viewBox="'0 0 10.456 13.444'"
                size="small"
                :classNames="'alert bg-[rgb(248,248,248)] button button--only-icon contact-modal-links dark:bg-transparent has-tooltip small delete-button'"
                @click="removeInputBox(index)"
              />
            </div>

            <woot-button
              color-scheme="primary"
              variant="smooth"
              size="small"
              @click="addInputBox"
            >
              Add guest
            </woot-button>
          </div>

        </div>
      </div>

      <div
        class="footer flex flex-col items-start pt-8 px-8 pb-8 remainder-footer"
      >
        <div>
          <woot-button variant="clear" @click.prevent="onClose">
            {{ $t('MERGE_CONTACTS.FORM.CANCEL') }}
          </woot-button>
        </div>

        <div v-if="scheduleType === 'reminder'">
          <woot-button
            type="submit"
            :is-disabled="sending_data"
            :is-loading="sending_data"
            @click.prevent="setRemainder"
          >
            {{ $t('MERGE_CONTACTS.FORM.SUBMIT_REMAINDER') }}
          </woot-button>
        </div>
        <div v-else-if="scheduleType === 'demo'">
          <woot-button
            type="submit"
            :disabled="
              sending_data || hasValidationErrors || demoNote.length === 0
            "
            :is-loading="sending_data"
            @click.prevent="setRemainder"
          >
            {{ 'Set demo' }}
          </woot-button>
        </div>
      </div>
    </woot-modal>
  </div>
</template>
  
<script>
import alertMixin from 'shared/mixins/alertMixin';
import MergeContact from 'dashboard/modules/contact/components/MergeContact';
import ContactAPI from 'dashboard/api/contacts';
import { mapGetters } from 'vuex';
import { CONTACTS_EVENTS } from '../../helper/AnalyticsHelper/events';
import WootDateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';
import contactsMixin from '../contact/helpers/contactsMixin';
import validations from '../contact/helpers/validations';

export default {
  components: { MergeContact, WootDateTimePicker },
  mixins: [alertMixin, contactsMixin],
  props: {
    primaryContact: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    currentChat: {
      type: Object,
      default: () => ({}),
    },
    datePart: String,
    timeWithoutZ: String,
  },
  data() {
    return {
      scheduleType: 'reminder',
      meetingLink: '',
      meetingLinkError: '',
      isSearching: false,
      searchResults: [],
      date: '',
      reminderNote: '',
      demoNote: '',
      time: '',
      scheduledAt: null,
      sending_data: false,
      guests: [{ id: Date.now(), email: '' }],
      slotTiming: 0
    };
  },
  validations,
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      records: 'labels/getLabels',
      conversationId: 'getSelectedChat',
      uiFlags: 'labels/getUIFlags',
    }),
    minDate() {
      // Get the current date
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    minTime() {
      // Get the current time
      const now = new Date();
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();

      // If selected date is today, disable previous times
      if (this.date === this.minDate) {
        return `${currentHours.toString().padStart(2, '0')}:${currentMinutes
          .toString()
          .padStart(2, '0')}`;
      } else {
        return '00:00'; // Allow any time if not today
      }
    },
    hasValidationErrors() {
      return this.$v?.$invalid;
    },
  },
  mounted() {
    this.$store.dispatch('labels/get');
    if (this.datePart && this.timeWithoutZ) {
      const dateTimeString = `${this.datePart} ${this.timeWithoutZ}`;
      // Convert to a Date object if both datePart and timeWithoutZ are provided
      this.scheduledAt = new Date(dateTimeString);
    } else {
      // Use the current date and time if either datePart or timeWithoutZ is empty
      this.scheduledAt = new Date();
    }
    this.assignMeetlink();
    this.getSlot();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    async onContactSearch(query) {
      this.isSearching = true;
      this.searchResults = [];

      try {
        const {
          data: { payload },
        } = await ContactAPI.search(query);
        this.searchResults = payload.filter(
          contact => contact.id !== this.primaryContact.id
        );
      } catch (error) {
        this.showAlert(this.$t('MERGE_CONTACTS.SEARCH.ERROR_MESSAGE'));
      } finally {
        this.isSearching = false;
      }
    },
    async onMergeContacts(childContactId) {
      this.$track(CONTACTS_EVENTS.MERGED_CONTACTS);
      try {
        await this.$store.dispatch('contacts/merge', {
          childId: childContactId,
          parentId: this.primaryContact.id,
        });
        this.showAlert(this.$t('MERGE_CONTACTS.FORM.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        this.showAlert(this.$t('MERGE_CONTACTS.FORM.ERROR_MESSAGE'));
      }
    },
    async setRemainder() {
      this.$v.$touch();
      if (this.$v.$invalid && this.scheduleType === 'demo') return;
      if (this.scheduledAt != null) {
        const dateObj = new Date(this.scheduledAt);
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log("User's Timezone:", timeZone, dateObj);
        console.log('My Schedule At', this.scheduledAt);
        console.log('Current User', this.currentUser);
        if (
          this.scheduleType === 'demo' &&
          (!this.primaryContact?.email ||
            this.primaryContact.email.trim() === '')
        ) {
          this.showAlert('Contact must have an email to schedule a demo.');
          return;
        }
        try {
          this.sending_data = true;
          const dateObj = new Date(this.scheduledAt);
          const optionsDate = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          };
          const optionsTime = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          };

          const formattedDate = dateObj.toLocaleDateString(
            'en-US',
            optionsDate
          );
          const formattedTime = dateObj
            .toLocaleTimeString('en-US', optionsTime)
            .replace(' ', '')
            .toUpperCase();
          const message = {
            content: `Your Demo Schedule at ${formattedDate} ${formattedTime}`,
            private: true,
          };

          let dateString = this.scheduledAt.toString();

          // Parse the date string and extract the GMT offset
          let dateParts = dateString.split(' ');
          let timeParts = dateParts[4].split(':');
          let hour = parseInt(timeParts[0]);
          let minute = parseInt(timeParts[1]);
          let second = parseInt(timeParts[2]);

          let dayName = dateParts[0];
          let monthName = dateParts[1];
          let day = dateParts[2];
          let year = dateParts[3];
          let gmtOffset = dateParts[5].substring(3, 8);

          // Convert the hour to 12-hour format
          let ampm = hour >= 12 ? 'PM' : 'AM';
          hour = hour % 12;
          hour = hour ? hour : 12; // the hour '0' should be '12'

          // Format the final date string
          let formattedDateString = `${dayName}, ${monthName} ${day}, ${year}, ${hour}:${String(
            minute
          ).padStart(2, '0')}:${second} ${ampm} ${gmtOffset}`;
          const calendar_timings = formattedDateString;

           let durationInMinutes = this.slotTiming || 0; 
          let durationInMs = durationInMinutes * 60 * 1000;

          let data =
            this.scheduleType === 'demo'
              ? {
                  scheduleType: this.scheduleType,
                  calendar_timings: calendar_timings,
                  meetingLink: this.meetingLink, // Will be updated
                  guests: this.guests
                    .map(g => g.email)
                    .filter(email => email && email.trim() !== ''),
                  userEmail: this.primaryContact?.email,
                  username: this.primaryContact?.name,
                  location: 'CONFERENCE_ROOM',
                  subject: this.demoNote,
                  endTime: dateObj.getTime() + durationInMs,
                  timeZone: timeZone,
                  startTime: dateObj.getTime(),
                  eventTypeId: this.currentUser.eventtype_id,
                  title: 'Demo',
                  status: 'confirmed',
                }
              : {
                  scheduleType: this.scheduleType,
                  calendar_timings: calendar_timings,
                  reminderNote: this.reminderNote,
                };

          // 2. First dispatch: set_demo — to get the meetLink

          if ( this.scheduleType === 'demo' && !data.eventTypeId){
          this.showAlert('EventType must be present for account');
          return;
        }
          
         if ( this.scheduleType === 'demo'){
          const setDemoResponse = await this.$store.dispatch(
            'contacts/set_demo',
            {
              conversationId: this.conversationId.messages[0].conversation_id,
              data: data,
            }
          );

          this.showAlert(setDemoResponse.message, {success: setDemoResponse.success})
          // 3. Get meeting link from the response
          const meetLink =
            setDemoResponse?.meetingLink ||
            setDemoResponse?.data?.calendarEventData.hangoutLink;

            // this.showAlert()
          // 4. Update the data with the new meetLink (for demo only)
          if (this.scheduleType === 'demo' && meetLink) {
            data.meetingLink = meetLink;
          }
          // console.log('My Response Data', setDemoResponse);
        }
          const response = await this.$store.dispatch('contacts/demo_time', {
            conversationId: this.conversationId.messages[0].conversation_id,
            data: data,
          });
          console.log('My Response', response);
          if (response.success == true) {
            const conversationId =
              this.conversationId.messages[0].conversation_id;
            const message = response.message;
            const demo_time = this.scheduledAt;
            this.$emit('success-message', {
              message,
              conversationId,
              formattedDate,
              formattedTime,
              demo_time,
            });
            this.onClose();
            this.sending_data = false;
          }
        } catch (err) {
          this.onClose();
          console.log(err.response)
          console.error('Error while Submitting the Data:-', err);
          this.showAlert(err.response?.data?.message, {success: err.response?.data?.success})
        }
      } else {
        this.showAlert('Schedule Demo Time is Mandatory Field');
      }
    },
    formatDate(dateStirng) {
      const date = new Date(dateStirng);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatTime(timeString) {
      const cleanedTimeString = timeString.replace(/ /g, '');
      const time = cleanedTimeString.slice(0, -2);
      const modifier = cleanedTimeString.slice(-2);
      let [hours, minutes] = time.split(':');

      if (modifier === 'PM' && hours !== '12') {
        hours = parseInt(hours, 10) + 12;
      }
      if (modifier === 'AM' && hours === '12') {
        hours = '00';
      }
      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getCurrentTime() {
      const date = new Date();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    onChange(value) {
      this.scheduledAt = value;
    },
    validateMeetingLink() {
      // Trim the input to remove leading and trailing spaces
      const link = this.meetingLink.trim();

      if (!link) {
        this.meetingLinkError = '';
        return;
      }

      const urlPattern =
        /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;

      // Validate the link and set the error message if invalid
      if (!urlPattern.test(link)) {
        this.meetingLinkError = 'Please enter a valid link.';
      } else {
        this.meetingLinkError = ''; // Clear the error if the link is valid
      }
    },
    addInputBox() {
      this.guests.push({ id: Date.now() + Math.random(), email: '' });
    },

    removeInputBox(index) {
      this.guests.splice(index, 1); // ✅ Vuelidate will sync automatically
    },

    getEmailError(index) {
      const field = this.$v.guests?.$each?.[index]?.email;
      if (!field || !field.$dirty) return '';
      if (!field.required || !field.email)
        return 'Please enter the correct Email';
      return '';
    },
    assignMeetlink() {
      this.meetingLink = this.currentChat?.custom_attributes?.meet_link || '';
    },
    async getSlot(){
      console.log("My Slot");
      const response=await this.$store.dispatch('contacts/getslot', {
        eventId: this.currentUser.eventtype_id
          });
      console.log("Response",response);
      if(!response){
        this.showAlert("Please add slot timing in Kivo calander");
      }
      this.slotTiming = response;
    }
  },
};
</script>
<style lang="scss" scoped>
.schedule-meeting-table {
  margin: 10px 25px;
}

.schedule-type {
  // margin: 10px 25px;
}

.remainder-table {
  // margin: 10px 25px;
}

.remainder-modal {
  display: flex;
}

.remainder-input {
  width: 100%;
}
.remainder-text {
  width: 20%;
  font-size: 14px;
  font-weight: 500;
}
.remainder-text-select {
  padding: 5% 0px;
}
.input-textarea textarea {
  resize: none;
}
.date-time {
  display: flex;
  justify-content: space-between;
}
.date,
.time {
  margin: 0px 2%;
}
.remainder-time {
  display: flex;
  justify-content: inherit;
  width: 35%;
}
.date-time-input {
  width: 100%;
}
.footer {
  @apply mt-6 flex justify-end;
}
.remainder-time select {
  width: 66%;
}
.remainder-footer {
  flex-direction: inherit;
}
.labels-dropdown {
  display: flex;
  width: 45%;
  justify-content: space-evenly;
}
.automation-dropdown {
  display: flex;
  width: 45%;
  justify-content: space-evenly;
}
.label-automation {
  padding-top: 10px;
  justify-content: space-between;
}
.labels-text {
  width: 30%;
}
.label-input {
  width: 50%;
}
.automation-text {
  width: 55%;
}
.automation-input {
  width: 50%;
}
.overlay {
  position: fixed;
  margin: auto;
  left: 50vw;
  width: 250px;
}
.success-popup {
  background-color: #44ce4b;
  color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  position: relative;
}
.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
}
.date-time-picker-modal {
  width: 100%;
  padding-top: 0px;
}
.error-message {
  font-size: 14px;
  margin-bottom: 4px;
}

.delete-button {
  bottom: 10px;
  position: relative;
}
.borderRadius{
  border-radius: 3px !important;
      border-color: #dcd0d0
}
</style>
